import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useSignature } from '../../contexts/SignatureContext';

export function MainLayout() {
  const { colors, mode } = useSignature();

  return (
    <div
      className="flex flex-col h-screen font-sans overflow-hidden select-none transition-colors duration-300"
      style={{
        backgroundColor: colors.bgApp,
        color: colors.textPrimary,
      }}
    >
      <Header />
      
      <div className="flex-1 flex overflow-hidden">
        <Sidebar open={true} />
        
        <div
          className="flex-1 flex flex-col overflow-y-auto scrollbar-standard"
          style={{ backgroundColor: colors.bgApp }}
        >
          <Outlet context={{ sidebarOpen: true, mode }} />
        </div>
      </div>
    </div>
  );
}
